import instance from "../../../services/api";

export const fetchProjects = params => {
  return instance(true)
    .post(`/partner/projects/`, params)
    .then((res = {}) => res?.data);
};
